
import { useQuery } from "@tanstack/react-query";
import { toast } from 'react-toastify';
import { getLikedNft } from "../../API/functions";


export const useGetLikedNft = ({ walletAddress,tier }) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["getLikedNft", walletAddress,tier], 
    queryFn: () => getLikedNft({ walletAddress,tier}),  
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "An error occurred");
    },
  });

  return { data, error, isLoading };
};



// import { useMutation } from "@tanstack/react-query";
// import { toast } from "react-toastify";
// import { getLikedNft } from "../../API/functions";

// export const useGetLikedNft = () => {

//   const { mutate, isLoading, error, data } = useMutation({
//     // mutationKey: ["getLikedNft"],
//     mutationFn: (vars) => getLikedNft(vars),
//     onSuccess: (data) => {
//       toast.success(data.message);
//     },
//     onError: (error) => {
//       toast.error(error.response.data.message);
//     },
//   });
//   return { mutate, isLoading, error, data };
// };


